// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Core__Math = require("@rescript/core/src/Core__Math.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var MM_provers = require("../mm-utils/MM_provers.res.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ColumnWidth = require("../ui-utils/ColumnWidth.res.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.res.js");
var PaginationCmp = require("../ui-utils/PaginationCmp.res.js");
var ReactDOMStyle = require("@rescript/react/src/ReactDOMStyle.res.js");
var MM_cmp_pe_stmt = require("./MM_cmp_pe_stmt.res.js");
var MM_proof_table = require("../mm-utils/MM_proof_table.res.js");
var MM_wrk_LoadCtx = require("../worker/MM_wrk_LoadCtx.res.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var Belt_HashSetInt = require("rescript/lib/js/belt_HashSetInt.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var MM_substitution = require("../mm-utils/MM_substitution.res.js");
var MM_wrk_settings = require("../worker/MM_wrk_settings.res.js");
var Expln_React_Menu = require("../../rescript-utils/main/react-mui-components/Expln_React_Menu.res.js");
var MM_cmp_user_stmt = require("../ui/MM_cmp_user_stmt.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var MM_proof_verifier = require("../mm-utils/MM_proof_verifier.res.js");
var MM_statements_dto = require("../mm-utils/MM_statements_dto.res.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var MM_cmp_jstf_to_svg = require("./MM_cmp_jstf_to_svg.res.js");
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var MM_wrk_pre_ctx_data = require("../worker/MM_wrk_pre_ctx_data.res.js");
var Button = require("@mui/material/Button").default;
var MM_cmp_pe_frame_descr = require("./MM_cmp_pe_frame_descr.res.js");
var MenuItem = require("@mui/material/MenuItem").default;
var Menu = require("@mui/icons-material/Menu").default;
var IconButton = require("@mui/material/IconButton").default;
var MM_cmp_load_proof_to_editor = require("./MM_cmp_load_proof_to_editor.res.js");
var MM_cmp_pe_frame_summary_state = require("./MM_cmp_pe_frame_summary_state.res.js");

var $$location = window.location;

function calcProofRecordsPerPage(proofTable) {
  var totalNumOfSymbols = Core__Array.reduce(proofTable, 0, (function (acc, r) {
          return acc + r.expr.length | 0;
        }));
  var totalNumOfSteps = proofTable.length;
  var avgNumOfSymbolsPerStep = totalNumOfSymbols / totalNumOfSteps | 0;
  var maxStepsPerPage = 50000 / avgNumOfSymbolsPerStep | 0;
  return Math.min(maxStepsPerPage, 500);
}

function setProofTable(st, proofTable, dummyVarDisj) {
  var frmCtx = st.frmCtx;
  var settings = st.settings;
  var typeColors = MM_wrk_settings.settingsGetTypeColors(settings);
  var exprsStr = proofTable.map(function (r) {
        return MM_context.ctxIntsToSymsExn(frmCtx, r.expr);
      });
  var vData = proofTable.map(function (pRec) {
        var match = pRec.proof;
        if (match.TAG === "Hypothesis") {
          return ;
        }
        var args = match.args;
        var frame = MM_context.getFrameExn(frmCtx, match.label);
        var hypsStr = [];
        var eHyps = [];
        frame.hyps.forEach(function (hyp, i) {
              hypsStr.push(MM_context.frmIntsToSymsExn(frmCtx, frame, hyp.expr));
              if (hyp.typ === "E") {
                eHyps.push(i);
                return ;
              }
              
            });
        var subs = Belt_HashMapString.make(frame.numOfVars);
        frame.hyps.forEach(function (hyp, i) {
              if (hyp.typ === "F") {
                return Belt_HashMapString.set(subs, frame.frameVarToSymb[hyp.expr[1]], exprsStr[args[i]].slice(1));
              }
              
            });
        var frmColors = Belt_HashMapString.make(frame.numOfVars);
        for(var i = 0 ,i_finish = frame.numOfVars; i < i_finish; ++i){
          var color = Belt_HashMapString.get(typeColors, MM_context.ctxIntToSymExn(frmCtx, frame.varTypes[i]));
          if (color !== undefined) {
            Belt_HashMapString.set(frmColors, frame.frameVarToSymb[i], color);
          }
          
        }
        return {
                hyps: hypsStr,
                eHyps: eHyps,
                asrt: MM_context.frmIntsToSymsExn(frmCtx, frame, frame.asrt),
                hypLabels: args,
                subs: subs,
                frmColors: frmColors
              };
      });
  var essIdxs = Belt_HashSetInt.make(1000);
  var stepRenum = Belt_HashMapInt.make(1000);
  proofTable.forEach(function (pRec) {
        var match = pRec.proof;
        if (match.TAG === "Hypothesis") {
          return ;
        }
        var args = match.args;
        var frame = MM_context.getFrameExn(frmCtx, match.label);
        frame.hyps.forEach(function (hyp, i) {
              if (hyp.typ === "E") {
                return Belt_HashSetInt.add(essIdxs, args[i]);
              }
              
            });
      });
  Belt_HashSetInt.add(essIdxs, proofTable.length - 1 | 0);
  proofTable.forEach(function (param, i) {
        if (Belt_HashSetInt.has(essIdxs, i)) {
          return Belt_HashMapInt.set(stepRenum, i, Belt_HashMapInt.size(stepRenum));
        }
        
      });
  var dummyVarDisjStr = !MM_context.disjIsEmpty(dummyVarDisj) ? MM_cmp_pe_frame_summary_state.createDisjGroups(MM_context.disjMutToDisjImm(dummyVarDisj), (function (i) {
            var sym = MM_context.ctxIntToSymExn(frmCtx, i);
            return [
                    sym,
                    Belt_HashMapString.get(st.symColors, sym)
                  ];
          }), (function (__x) {
            return MM_context.getTypeOfVar(frmCtx, __x);
          }), st.typeOrderInDisj) : undefined;
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.proofRecordsPerPage = calcProofRecordsPerPage(proofTable);
  newrecord.expandedIdxs = [];
  newrecord.stepRenum = stepRenum;
  newrecord.essIdxs = essIdxs;
  newrecord.showTypes = false;
  newrecord.vData = vData;
  newrecord.proofTable = proofTable;
  newrecord.dummyVarDisjStr = dummyVarDisjStr;
  newrecord.dummyVarDisj = MM_context.disjIsEmpty(dummyVarDisj) ? undefined : Caml_option.some(dummyVarDisj);
  return newrecord;
}

function createInitialState(settings, frmMmScopes, preCtx, frmCtx, frame) {
  var frmCtx$1 = MM_context.ctxOptimizeForProver(frmCtx, settings.parens, false, false, true);
  var frms = MM_substitution.prepareFrmSubsData(frmCtx$1);
  var parenCnt = MM_provers.makeParenCnt(frmCtx$1, settings.parens);
  var match = MM_wrk_pre_ctx_data.findTypes(frmCtx$1);
  var frmIntToCtxInt = function (i) {
    var n = MM_context.ctxSymToInt(frmCtx$1, i < 0 ? MM_context.ctxIntToSymExn(preCtx, i) : frame.frameVarToSymb[i]);
    if (n !== undefined) {
      return n;
    }
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "preCtx->ctxSymToInt == None in frmIntToCtxInt"
          },
          Error: new Error()
        };
  };
  var ctxVarToFrmVar = function (i) {
    var n = frame.frameVarToSymb.indexOf(MM_context.ctxIntToSymExn(frmCtx$1, i));
    if (n !== -1) {
      return n;
    }
    
  };
  var typeColors = MM_wrk_settings.settingsGetTypeColors(settings);
  var symColors = MM_wrk_pre_ctx_data.createSymbolColors(frmCtx$1, typeColors);
  var asrt = frame.asrt.map(frmIntToCtxInt);
  var typeOrderInDisj = Common.createTypeOrderFromStr(settings.sortDisjByType, (function (__x) {
          return MM_context.ctxSymToInt(frmCtx$1, __x);
        }));
  var disjStr = Belt_MapInt.size(frame.disj) > 0 ? MM_cmp_pe_frame_summary_state.createDisjGroups(frame.disj, (function (i) {
            var sym = MM_context.frmIntToSymExn(frmCtx$1, frame, i);
            return [
                    sym,
                    Belt_HashMapString.get(symColors, sym)
                  ];
          }), (function (i) {
            return MM_context.getTypeOfVar(frmCtx$1, frmIntToCtxInt(i));
          }), typeOrderInDisj) : undefined;
  var st_syntaxTypes = match[1];
  var st_hyps = frame.hyps.map(function (hyp) {
        return {
                typ: hyp.typ,
                label: hyp.label,
                expr: hyp.expr.map(frmIntToCtxInt)
              };
      });
  var st_vData = [];
  var st_essIdxs = Belt_HashSetInt.make(0);
  var st_stepRenum = Belt_HashMapInt.make(0);
  var st_expandedIdxs = [];
  var st = {
    settings: settings,
    frmMmScopes: frmMmScopes,
    frmCtx: frmCtx$1,
    frms: frms,
    parenCnt: parenCnt,
    syntaxTypes: st_syntaxTypes,
    typeOrderInDisj: typeOrderInDisj,
    frame: frame,
    disjStr: disjStr,
    dummyVarDisj: undefined,
    dummyVarDisjStr: undefined,
    hyps: st_hyps,
    asrt: asrt,
    proofTable: undefined,
    symColors: symColors,
    vData: st_vData,
    showTypes: false,
    essIdxs: st_essIdxs,
    stepRenum: st_stepRenum,
    expandedIdxs: st_expandedIdxs,
    syntaxProofTableWasRequested: false,
    syntaxProofTableError: undefined,
    proofRecordsPerPage: 300,
    pageIdx: 0
  };
  var proof = frame.proof;
  if (proof === undefined) {
    return st;
  }
  if (proof.TAG === "Uncompressed") {
    var match$1 = proof.labels;
    if (match$1.length === 1) {
      var match$2 = match$1[0];
      if (match$2 === "?") {
        return st;
      }
      
    }
    
  }
  var dummyVarDisj = MM_context.disjMake();
  var proofRoot = MM_proof_verifier.verifyProof(frmCtx$1, asrt, proof, (function (n, m) {
          var n$1 = ctxVarToFrmVar(n);
          var isFrmDisj;
          if (n$1 !== undefined) {
            var m$1 = ctxVarToFrmVar(m);
            isFrmDisj = m$1 !== undefined ? MM_context.disjImmContains(frame.disj, n$1, m$1) : false;
          } else {
            isFrmDisj = false;
          }
          if (!isFrmDisj) {
            MM_context.disjAddPair(dummyVarDisj, n, m);
          }
          return true;
        }));
  return setProofTable(st, MM_proof_table.createProofTableFromProof(proofRoot, undefined), dummyVarDisj);
}

function setShowTypes(st, showTypes) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.showTypes = showTypes;
  return newrecord;
}

function toggleShowTypes(st) {
  return setShowTypes(st, !st.showTypes);
}

function setSyntaxProofTableWasRequested(st, syntaxProofTableWasRequested) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.syntaxProofTableWasRequested = syntaxProofTableWasRequested;
  return newrecord;
}

function setSyntaxProofTableError(st, syntaxProofTableError) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.syntaxProofTableError = syntaxProofTableError;
  return newrecord;
}

function loadFrameContext(srcs, label, descrRegexToDisc, labelRegexToDisc, descrRegexToDepr, labelRegexToDepr, onProgress, onDone) {
  var scopes = MM_wrk_LoadCtx.createMmScopesForFrame(srcs, label);
  MM_wrk_LoadCtx.beginLoadingMmContext(scopes, descrRegexToDisc, labelRegexToDisc, descrRegexToDepr, labelRegexToDepr, onProgress, (function (res) {
          if (res.TAG === "Ok") {
            return onDone({
                        TAG: "Ok",
                        _0: [
                          scopes,
                          res._0
                        ]
                      });
          } else {
            return onDone({
                        TAG: "Error",
                        _0: res._0
                      });
          }
        }));
}

var dotPattern = /\./g;

function propsAreSame(a, b) {
  if (a.top === b.top && a.ctxSelectorIsExpanded === b.ctxSelectorIsExpanded) {
    return a.preCtxData.ctxV.ver === b.preCtxData.ctxV.ver;
  } else {
    return false;
  }
}

function rndIconButton(icon, onClick, active, notifyEditInTempMode, ref, title, smallBtnsOpt) {
  var smallBtns = smallBtnsOpt !== undefined ? smallBtnsOpt : false;
  return React.createElement("span", {
              ref: ref,
              title: title
            }, React.createElement(IconButton, {
                  onClick: (function (param) {
                      if (notifyEditInTempMode !== undefined) {
                        return notifyEditInTempMode(function () {
                                    onClick();
                                  });
                      } else {
                        return onClick();
                      }
                    }),
                  color: "primary",
                  style: smallBtns ? ({
                        padding: "2px"
                      }) : undefined,
                  disabled: !active,
                  children: Caml_option.some(icon)
                }));
}

function convertMmScopesToMmCtxSrcDtos(origMmCtxSrcDtos, mmScopes) {
  var canConvert = mmScopes.length <= origMmCtxSrcDtos.length && mmScopes.every(function (mmScope, i) {
        return Belt_Option.getWithDefault(Belt_Option.map(origMmCtxSrcDtos[i].ast, (function (origAst) {
                          return Caml_obj.equal(origAst, mmScope.ast);
                        })), false);
      });
  if (canConvert) {
    return mmScopes.map(function (mmScope, i) {
                var origMmCtxSrcDto = origMmCtxSrcDtos[i];
                var label = mmScope.stopBefore;
                var match;
                if (label !== undefined) {
                  match = [
                    MM_wrk_editor.readInstrToStr("StopBefore"),
                    label
                  ];
                } else {
                  var label$1 = mmScope.stopAfter;
                  match = label$1 !== undefined ? [
                      MM_wrk_editor.readInstrToStr("StopAfter"),
                      label$1
                    ] : [
                      MM_wrk_editor.readInstrToStr("ReadAll"),
                      ""
                    ];
                }
                return {
                        typ: origMmCtxSrcDto.typ,
                        fileName: origMmCtxSrcDto.fileName,
                        url: origMmCtxSrcDto.url,
                        readInstr: match[0],
                        label: match[1],
                        resetNestingLevel: true,
                        ast: origMmCtxSrcDto.ast,
                        allLabels: origMmCtxSrcDto.allLabels
                      };
              });
  }
  
}

function makeFrameProofData(preCtxData, label, onProgress) {
  return Expln_utils_promise.promise(function (resolve) {
              loadFrameContext(preCtxData.srcs, label, preCtxData.settingsV.val.descrRegexToDisc, preCtxData.settingsV.val.labelRegexToDisc, preCtxData.settingsV.val.descrRegexToDepr, preCtxData.settingsV.val.labelRegexToDepr, onProgress, (function (res) {
                      if (res.TAG !== "Ok") {
                        return resolve({
                                    TAG: "Error",
                                    _0: res._0
                                  });
                      }
                      var match = res._0;
                      var frame = MM_context.getFrame(preCtxData.ctxV.val.full, label);
                      resolve(frame !== undefined ? ({
                                TAG: "Ok",
                                _0: createInitialState(preCtxData.settingsV.val, match[0], preCtxData.ctxV.val.full, match[1], frame)
                              }) : ({
                                TAG: "Error",
                                _0: "Cannot find a frame by the label '" + label + "'"
                              }));
                    }));
            });
}

function getStepNum(state, pRecIdx) {
  if (state.showTypes) {
    return pRecIdx + 1 | 0;
  } else {
    return Belt_Option.getWithDefault(Belt_Option.map(Belt_HashMapInt.get(state.stepRenum, pRecIdx), (function (n) {
                      return n + 1 | 0;
                    })), 0);
  }
}

function pRecIdxToLabel(state, proofTable, pRecIdx, maxUsedStepNum) {
  var match = proofTable[pRecIdx].proof;
  if (match.TAG === "Hypothesis") {
    return match.label;
  }
  var stepNum = getStepNum(state, pRecIdx);
  return String(Belt_Option.getWithDefault(Belt_Option.map(maxUsedStepNum, (function (maxUsedStepNum) {
                        return stepNum <= maxUsedStepNum;
                      })), false) ? Belt_Option.getExn(maxUsedStepNum) + 1 | 0 : stepNum);
}

function frameProofDataToEditorStateLocStor(preCtxData, frameProofData, adjustContext, loadSteps) {
  var vars = [];
  MM_context.forEachHypothesisInDeclarationOrder(frameProofData.frmCtx, (function (hyp) {
          if (hyp.typ === "F") {
            var match = MM_context.getTokenType(preCtxData.ctxV.val.full, MM_context.ctxIntToSymExn(frameProofData.frmCtx, hyp.expr[1]));
            var exit = 0;
            if (match !== "V") {
              exit = 1;
            }
            if (exit === 1) {
              vars.push(hyp.label + " " + MM_context.ctxIntsToStrExn(frameProofData.frmCtx, hyp.expr));
            }
            
          }
          
        }));
  var disjArr = [];
  var frmDisj = MM_context.disjMake();
  Belt_MapInt.forEach(frameProofData.frame.disj, (function (n, ms) {
          Belt_SetInt.forEach(ms, (function (m) {
                  MM_context.disjAddPair(frmDisj, n, m);
                }));
        }));
  MM_context.disjForEachArr(frmDisj, undefined, undefined, undefined, undefined, (function (disjGrp) {
          disjArr.push(MM_context.frmIntsToSymsExn(preCtxData.ctxV.val.full, frameProofData.frame, disjGrp).join(" "));
        }));
  var dummyVarDisj = frameProofData.dummyVarDisj;
  if (dummyVarDisj !== undefined) {
    MM_context.disjForEachArr(Caml_option.valFromOption(dummyVarDisj), undefined, undefined, undefined, undefined, (function (disjGrp) {
            disjArr.push(MM_context.ctxIntsToSymsExn(frameProofData.frmCtx, disjGrp).join(" "));
          }));
  }
  var maxUsedStepNum = {
    contents: 0
  };
  var stmts = [];
  frameProofData.frame.hyps.forEach(function (hyp) {
        if (hyp.typ !== "E") {
          return ;
        }
        var i = Belt_Int.fromString(hyp.label);
        if (i !== undefined && maxUsedStepNum.contents < i) {
          maxUsedStepNum.contents = i;
        }
        stmts.push({
              label: hyp.label,
              typ: MM_wrk_editor.userStmtTypeToStr("E"),
              isGoal: false,
              isBkm: false,
              cont: MM_context.frmIntsToStrExn(preCtxData.ctxV.val.full, frameProofData.frame, hyp.expr),
              jstfText: ""
            });
      });
  var proofTable = frameProofData.proofTable;
  if (proofTable !== undefined) {
    var idxToLabel = Belt_HashMapInt.make(proofTable.length);
    proofTable.map(function (pRec, idx) {
              return [
                      pRec,
                      idx
                    ];
            }).filter(function (param) {
            return Belt_HashSetInt.has(frameProofData.essIdxs, param[1]);
          }).forEach(function (param) {
          var idx = param[1];
          var pRec = param[0];
          var match = pRec.proof;
          if (match.TAG === "Hypothesis") {
            return Belt_HashMapInt.set(idxToLabel, idx, match.label);
          }
          var args = match.args;
          var isGoal = idx === (proofTable.length - 1 | 0);
          if (!(loadSteps || isGoal)) {
            return ;
          }
          var jstfArgs = [];
          for(var i = 0 ,i_finish = args.length; i < i_finish; ++i){
            var argIdx = args[i];
            if (Belt_HashSetInt.has(frameProofData.essIdxs, argIdx)) {
              var str = Belt_HashMapInt.get(idxToLabel, argIdx);
              var label = str !== undefined ? str : "err_" + String(argIdx);
              jstfArgs.push(label);
            }
            
          }
          var jstfText = loadSteps ? MM_statements_dto.jstfToStr({
                  args: jstfArgs,
                  label: match.label
                }) : "";
          var label$1 = isGoal ? frameProofData.frame.label : pRecIdxToLabel(frameProofData, proofTable, idx, maxUsedStepNum.contents);
          Belt_HashMapInt.set(idxToLabel, idx, label$1);
          var i$1 = Belt_Int.fromString(label$1);
          if (i$1 !== undefined && maxUsedStepNum.contents < i$1) {
            maxUsedStepNum.contents = i$1;
          }
          stmts.push({
                label: label$1,
                typ: MM_wrk_editor.userStmtTypeToStr("P"),
                isGoal: isGoal,
                isBkm: false,
                cont: MM_context.ctxIntsToStrExn(frameProofData.frmCtx, pRec.expr),
                jstfText: jstfText
              });
        });
  } else {
    stmts.push({
          label: frameProofData.frame.label,
          typ: MM_wrk_editor.userStmtTypeToStr("P"),
          isGoal: true,
          isBkm: false,
          cont: MM_context.ctxIntsToStrExn(frameProofData.frmCtx, frameProofData.asrt),
          jstfText: ""
        });
  }
  var srcs;
  if (adjustContext) {
    var srcs$1 = convertMmScopesToMmCtxSrcDtos(preCtxData.srcs, frameProofData.frmMmScopes);
    srcs = srcs$1 !== undefined ? srcs$1 : [];
  } else {
    srcs = [];
  }
  return {
          tabTitle: frameProofData.frame.label,
          srcs: srcs,
          descr: Belt_Option.getWithDefault(frameProofData.frame.descr, ""),
          varsText: vars.join("\n"),
          disjText: disjArr.join("\n"),
          stmts: stmts
        };
}

function frameProofDataToStmtsDto(preCtxData, wrkCtx, proofTreeDto, args, frameProofData) {
  var frmVarToCtxExpr = Belt_HashMapString.fromArray(args.map(function (arg, i) {
                var hyp = frameProofData.frame.hyps[i];
                if (hyp.typ === "F") {
                  return [
                          MM_context.frmIntToSymExn(wrkCtx, frameProofData.frame, hyp.expr[1]),
                          MM_context.ctxIntsToStrExn(wrkCtx, proofTreeDto.nodes[arg].expr.slice(1))
                        ];
                }
                
              }).filter(Belt_Option.isSome).map(Belt_Option.getExn));
  var locSt = frameProofDataToEditorStateLocStor(preCtxData, frameProofData, false, true);
  var stmts = Core__Array.reduce(locSt.stmts, {
        TAG: "Ok",
        _0: []
      }, (function (res, stmt) {
          if (res.TAG !== "Ok") {
            return res;
          }
          res._0.push({
                label: stmt.label,
                expr: (function (__x) {
                      return MM_context.ctxStrToIntsExn(wrkCtx, __x);
                    })(Common.getSpaceSeparatedValuesAsArray(stmt.cont).map(function (sym) {
                            var exprStr = Belt_HashMapString.get(frmVarToCtxExpr, sym);
                            if (exprStr !== undefined) {
                              return exprStr;
                            } else {
                              return sym;
                            }
                          }).join(" ")),
                exprStr: "",
                jstf: Belt_Result.getWithDefault(MM_wrk_editor.parseJstf(stmt.jstfText), undefined),
                isProved: true
              });
          return res;
        }));
  return Belt_Result.map(stmts, (function (stmts) {
                return {
                        newVars: [],
                        newVarTypes: [],
                        newDisj: MM_context.disjMake(),
                        newDisjStr: [],
                        stmts: stmts
                      };
              }));
}

var make = React.memo((function (param) {
        var ctxSelectorIsExpanded = param.ctxSelectorIsExpanded;
        var toggleCtxSelector = param.toggleCtxSelector;
        var openEditor = param.openEditor;
        var openExplorer = param.openExplorer;
        var openFrameExplorer = param.openFrameExplorer;
        var label = param.label;
        var preCtxData = param.preCtxData;
        var modalRef = param.modalRef;
        var top = param.top;
        var match = React.useState(function () {
              return preCtxData.ctxV.ver;
            });
        var setLastPreCtxVer = match[1];
        var lastPreCtxVer = match[0];
        var match$1 = React.useState(function () {
              return false;
            });
        var setRefreshIsNeeded = match$1[1];
        var match$2 = React.useState(function () {
              return 0;
            });
        var setLoadPct = match$2[1];
        var loadPct = match$2[0];
        var match$3 = React.useState(function () {
              
            });
        var setLoadErr = match$3[1];
        var loadErr = match$3[0];
        var match$4 = React.useState(function () {
              
            });
        var setState = match$4[1];
        var state = match$4[0];
        var match$5 = React.useState(function () {
              return "100px";
            });
        var setStepWidth = match$5[1];
        var stepWidth = match$5[0];
        var match$6 = React.useState(function () {
              return "100px";
            });
        var setHypWidth = match$6[1];
        var hypWidth = match$6[0];
        var match$7 = React.useState(function () {
              return "100px";
            });
        var setRefWidth = match$7[1];
        var refWidth = match$7[0];
        var match$8 = React.useState(function () {
              return false;
            });
        var setMainMenuIsOpened = match$8[1];
        var mainMenuIsOpened = match$8[0];
        var mainMenuButtonRef = React.useRef(null);
        var actPreCtxDataChanged = function () {
          setTimeout((function () {
                  loadFrameContext(preCtxData.srcs, label, preCtxData.settingsV.val.descrRegexToDisc, preCtxData.settingsV.val.labelRegexToDisc, preCtxData.settingsV.val.descrRegexToDepr, preCtxData.settingsV.val.labelRegexToDepr, (function (pct) {
                          setLoadPct(function (param) {
                                return pct;
                              });
                        }), (function (res) {
                          if (res.TAG === "Ok") {
                            var match = res._0;
                            var frmCtx = match[1];
                            var frmMmScopes = match[0];
                            setLoadPct(function (param) {
                                  return 1.0;
                                });
                            var state = Common.catchExn(function () {
                                  return createInitialState(preCtxData.settingsV.val, frmMmScopes, preCtxData.ctxV.val.full, frmCtx, MM_context.getFrameExn(preCtxData.ctxV.val.full, label));
                                });
                            if (state.TAG === "Ok") {
                              var state$1 = state._0;
                              return setState(function (param) {
                                          return state$1;
                                        });
                            }
                            var msg = state._0.msg;
                            return setLoadErr(function (param) {
                                        return msg;
                                      });
                          }
                          var msg$1 = res._0;
                          setLoadErr(function (param) {
                                return msg$1;
                              });
                        }));
                }), 10);
        };
        var actRefreshOnPreCtxDataChange = function () {
          actPreCtxDataChanged();
          setLastPreCtxVer(function (param) {
                return preCtxData.ctxV.ver;
              });
          setRefreshIsNeeded(function (param) {
                return false;
              });
        };
        React.useEffect((function () {
                if (lastPreCtxVer !== preCtxData.ctxV.ver) {
                  setRefreshIsNeeded(function (param) {
                        return true;
                      });
                  setState(function (param) {
                        
                      });
                  setLoadErr(function (param) {
                        
                      });
                } else {
                  actPreCtxDataChanged();
                }
              }), [preCtxData.ctxV.ver]);
        var modifyState = function (update) {
          setState(function (st) {
                if (st !== undefined) {
                  return update(st);
                }
                
              });
        };
        var actOpenMainMenu = function () {
          setMainMenuIsOpened(function (param) {
                return true;
              });
        };
        var actCloseMainMenu = function () {
          setMainMenuIsOpened(function (param) {
                return false;
              });
        };
        var actBuildSyntaxProofTable = function () {
          modifyState(function (st) {
                var ctx = st.frmCtx;
                var msg = MM_wrk_editor.textToSyntaxProofTable(ctx, [MM_context.ctxIntsToSymsExn(ctx, (function (__x) {
                                return __x.slice(1);
                              })(st.asrt))], st.syntaxTypes, st.frms, preCtxData.settingsV.val.allowedFrms.inSyntax, st.parenCnt, MM_cmp_user_stmt.getLastSyntaxType(), MM_cmp_user_stmt.setLastSyntaxType);
                if (msg.TAG !== "Ok") {
                  return setSyntaxProofTableError(st, msg._0);
                }
                var msg$1 = msg._0[0];
                if (msg$1.TAG !== "Ok") {
                  return setSyntaxProofTableError(st, msg$1._0);
                }
                var st$1 = setProofTable(st, msg$1._0, MM_context.disjMake());
                return setShowTypes(st$1, true);
              });
        };
        var actSyntaxProofTableWasRequested = function () {
          modifyState(function (__x) {
                return setSyntaxProofTableWasRequested(__x, true);
              });
        };
        var syntaxProofTableWasRequested = Belt_Option.getWithDefault(Belt_Option.map(state, (function (st) {
                    return st.syntaxProofTableWasRequested;
                  })), false);
        React.useEffect((function () {
                if (syntaxProofTableWasRequested) {
                  setTimeout((function () {
                          modifyState(function (__x) {
                                return setSyntaxProofTableWasRequested(__x, false);
                              });
                          actBuildSyntaxProofTable();
                        }), 10);
                }
                
              }), [syntaxProofTableWasRequested]);
        var actLoadProofToEditor = function (state, adjustContext, loadSteps) {
          openEditor(frameProofDataToEditorStateLocStor(preCtxData, state, adjustContext, loadSteps));
        };
        var getNumberOfRowsInProofTable = function (state) {
          if (state === undefined) {
            return 0;
          }
          var proofTable = state.proofTable;
          if (proofTable !== undefined) {
            if (state.showTypes) {
              return proofTable.length;
            } else {
              return Core__Array.reduceWithIndex(proofTable, 0, (function (cnt, param, idx) {
                            return cnt + (
                                    Belt_HashSetInt.has(state.essIdxs, idx) ? 1 : 0
                                  ) | 0;
                          }));
            }
          } else {
            return 0;
          }
        };
        var numberOfRowsInProofTable = getNumberOfRowsInProofTable(state);
        var proofTableId = "tbl-" + label;
        var classColStep = "step";
        var classColHyp = "hyp";
        var classColRef = "ref";
        React.useEffect((function () {
                var proofTableIdCssSelector = proofTableId.replace(dotPattern, "\\.");
                setStepWidth(function (param) {
                      return String(ColumnWidth.calcColumnWidth("#" + proofTableIdCssSelector + " ." + classColStep, 30, 1000)) + "px";
                    });
                setHypWidth(function (param) {
                      return String(ColumnWidth.calcColumnWidth("#" + proofTableIdCssSelector + " ." + classColHyp, 30, 100) + 5 | 0) + "px";
                    });
                setRefWidth(function (param) {
                      return String(ColumnWidth.calcColumnWidth("#" + proofTableIdCssSelector + " ." + classColRef, 30, 1000)) + "px";
                    });
              }), [
              numberOfRowsInProofTable,
              Core__Option.mapOr(state, 0, (function (st) {
                      return st.pageIdx;
                    }))
            ]);
        var getFrmLabelBkgColor = function (label) {
          var frm = MM_substitution.frmsGetByLabel(preCtxData.frms, label);
          if (frm !== undefined) {
            return MM_react_common.getFrmLabelBkgColor(frm.frame, preCtxData.settingsV.val);
          }
          
        };
        var rndLabel = function (state) {
          var asrtType = state.frame.isAxiom ? React.createElement("span", {
                  style: {
                    color: "red"
                  }
                }, "Axiom") : React.createElement("span", {
                  style: {
                    color: "green"
                  }
                }, "Theorem");
          var tmp = {
            cursor: "pointer",
            fontWeight: "bold",
            borderRadius: "3px"
          };
          var tmp$1 = getFrmLabelBkgColor(state.frame.label);
          if (tmp$1 !== undefined) {
            tmp.backgroundColor = tmp$1;
          }
          return React.createElement(Expln_React_Row.make, {
                      alignItems: "center",
                      spacing: 0,
                      childXsOffset: (function (idx) {
                          if (idx !== 1) {
                            return ;
                          } else {
                            return "auto";
                          }
                        }),
                      children: Caml_option.some(null)
                    }, React.createElement("span", undefined, asrtType, " ", React.createElement("span", {
                              style: tmp
                            }, state.frame.label), React.createElement("span", {
                              style: {
                                color: "grey",
                                fontFamily: "Arial Narrow",
                                fontSize: "x-small",
                                marginLeft: "5px"
                              }
                            }, " " + String(MM_substitution.frmsSize(state.frms) + 1 | 0))), rndIconButton(React.createElement(Menu, {}), actOpenMainMenu, true, undefined, Caml_option.some(mainMenuButtonRef), "Additional actions", undefined));
        };
        var rndMainMenu = function (state) {
          if (!mainMenuIsOpened) {
            return null;
          }
          var mainMenuButtonRef$1 = mainMenuButtonRef.current;
          if (mainMenuButtonRef$1 == null) {
            return null;
          } else {
            return React.createElement(Expln_React_Menu.make, {
                        opn: true,
                        anchorEl: Caml_option.some(mainMenuButtonRef$1),
                        onClose: actCloseMainMenu,
                        children: Caml_option.some(null)
                      }, React.createElement(MenuItem, {
                            onClick: (function () {
                                setMainMenuIsOpened(function (param) {
                                      return false;
                                    });
                                Belt_Option.forEach(Caml_option.nullable_to_opt(toggleCtxSelector.current), (function (toggleCtxSelector) {
                                        toggleCtxSelector();
                                      }));
                              }),
                            children: Caml_option.some(ctxSelectorIsExpanded ? "Hide context" : "Show context")
                          }), React.createElement(MenuItem, {
                            disabled: state.frame.isAxiom,
                            onClick: (function () {
                                setMainMenuIsOpened(function (param) {
                                      return false;
                                    });
                                Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                            return null;
                                          })), (function (modalId) {
                                        Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                                return React.createElement(MM_cmp_load_proof_to_editor.make, {
                                                            onOk: (function (adjustContext, loadSteps) {
                                                                actLoadProofToEditor(state, adjustContext, loadSteps);
                                                                Expln_React_Modal.closeModal(modalRef, modalId);
                                                              }),
                                                            onCancel: (function () {
                                                                Expln_React_Modal.closeModal(modalRef, modalId);
                                                              })
                                                          });
                                              }));
                                      }));
                              }),
                            children: "Open this proof in a new editor tab"
                          }));
          }
        };
        var rndSummary = function (state) {
          var style = {
            borderCollapse: "collapse"
          };
          return React.createElement("table", {
                      style: style
                    }, React.createElement("tbody", undefined, state.hyps.filter(function (hyp) {
                                return hyp.typ === "E";
                              }).map(function (hyp, i) {
                              return React.createElement("tr", {
                                          key: String(i)
                                        }, React.createElement("td", {
                                              style: Object.assign({}, style, {
                                                    paddingLeft: "15px"
                                                  })
                                            }, Common.circleChar + Common.nbsp + hyp.label), React.createElement("td", {
                                              style: Object.assign({}, style, {
                                                    paddingLeft: "10px"
                                                  })
                                            }, React.createElement(MM_cmp_pe_stmt.make, {
                                                  modalRef: modalRef,
                                                  ctx: state.frmCtx,
                                                  syntaxTypes: state.syntaxTypes,
                                                  frms: state.frms,
                                                  frameRestrict: preCtxData.settingsV.val.allowedFrms.inSyntax,
                                                  parenCnt: state.parenCnt,
                                                  stmt: hyp.expr,
                                                  symColors: state.symColors,
                                                  symRename: undefined,
                                                  editStmtsByLeftClick: preCtxData.settingsV.val.editStmtsByLeftClick,
                                                  openExplorer: openExplorer
                                                })));
                            }), React.createElement("tr", undefined, React.createElement("td", {
                                  style: {
                                    paddingTop: "10px",
                                    verticalAlign: "top"
                                  }
                                }, state.frame.label), React.createElement("td", {
                                  style: Object.assign({}, style, {
                                        paddingTop: "10px",
                                        paddingLeft: "10px",
                                        verticalAlign: "top"
                                      })
                                }, React.createElement(MM_cmp_pe_stmt.make, {
                                      modalRef: modalRef,
                                      ctx: state.frmCtx,
                                      syntaxTypes: state.syntaxTypes,
                                      frms: state.frms,
                                      frameRestrict: preCtxData.settingsV.val.allowedFrms.inSyntax,
                                      parenCnt: state.parenCnt,
                                      stmt: state.asrt,
                                      symColors: state.symColors,
                                      symRename: undefined,
                                      editStmtsByLeftClick: preCtxData.settingsV.val.editStmtsByLeftClick,
                                      openExplorer: openExplorer
                                    })))));
        };
        var rndDescr = function (state) {
          return React.createElement("span", undefined, React.createElement(MM_cmp_pe_frame_descr.make, {
                          settings: preCtxData.settingsV.val,
                          ctx: preCtxData.ctxV.val.full,
                          symColors: state.symColors,
                          openFrameExplorer: openFrameExplorer,
                          text: Belt_Option.getWithDefault(state.frame.descr, "This " + (
                                state.frame.isAxiom ? "axiom" : "theorem"
                              ) + " doesn't have a description.")
                        }));
        };
        var rndUsageCnt = function (state) {
          return React.createElement("span", undefined, "Referenced by: ", React.createElement("a", {
                          style: {
                            color: "blue",
                            cursor: "pointer",
                            textDecoration: "underline"
                          },
                          onClick: (function (param) {
                              openExplorer(undefined, state.frame.label);
                            })
                        }, state.frame.usageCnt.toString()));
        };
        var rndDisj = function (state) {
          var disj = state.disjStr;
          if (disj !== undefined) {
            return React.createElement("div", undefined, "Distinct variable groups:" + MM_cmp_pe_frame_summary_state.disjGrpDelim, MM_cmp_pe_frame_summary_state.rndDisj(disj));
          } else {
            return React.createElement("div", {
                        style: {
                          display: "none"
                        }
                      });
          }
        };
        var rndDummyVarDisj = function (state) {
          var disj = state.dummyVarDisjStr;
          if (disj !== undefined) {
            return React.createElement("div", undefined, "Distinct dummy variable groups:" + MM_cmp_pe_frame_summary_state.disjGrpDelim, MM_cmp_pe_frame_summary_state.rndDisj(disj));
          } else {
            return React.createElement("div", {
                        style: {
                          display: "none"
                        }
                      });
          }
        };
        var getAllProofRecordsToShow = function (state) {
          var proofTable = state.proofTable;
          if (proofTable !== undefined) {
            return proofTable.map(function (pRec, idx) {
                          return [
                                  pRec,
                                  idx
                                ];
                        }).filter(function (param) {
                        if (state.showTypes) {
                          return true;
                        } else {
                          return Belt_HashSetInt.has(state.essIdxs, param[1]);
                        }
                      });
          } else {
            return [];
          }
        };
        var actGoToPage = function (pageIdx) {
          setState(function (st) {
                return Core__Option.map(st, (function (st) {
                              var newrecord = Caml_obj.obj_dup(st);
                              newrecord.pageIdx = pageIdx;
                              return newrecord;
                            }));
              });
        };
        var actGoToPageWithStep = function (idx) {
          if (state === undefined) {
            return ;
          }
          var showedIdx = Core__Array.findIndexOpt(getAllProofRecordsToShow(state), (function (param) {
                  return param[1] === idx;
                }));
          if (showedIdx === undefined) {
            return ;
          }
          var pageIdx = Core__Math.Int.floor(showedIdx / state.proofRecordsPerPage);
          actGoToPage(pageIdx);
        };
        var rndHyp = function (state, pRec) {
          var match = pRec.proof;
          if (match.TAG === "Hypothesis") {
            return null;
          }
          var args = match.args;
          var elems = [];
          for(var i = 0 ,i_finish = args.length; i < i_finish; ++i){
            var argIdx = args[i];
            if (state.showTypes || Belt_HashSetInt.has(state.essIdxs, argIdx)) {
              var iStr = String(i);
              if (elems.length > 0) {
                elems.push(React.createElement("span", {
                          key: "delim-" + iStr
                        }, ", "));
              }
              elems.push(React.createElement("a", {
                        key: "hyp-" + iStr,
                        href: "#" + proofTableId + "-" + String(argIdx),
                        onClick: MM_react_common.clickHnd(undefined, undefined, undefined, undefined, (function(argIdx){
                            return function () {
                              actGoToPageWithStep(argIdx);
                              setTimeout((function () {
                                      MM_react_common.removeQueryParamsFromUrl("Removing proof record id.");
                                    }), 2000);
                            }
                            }(argIdx)))
                      }, String(getStepNum(state, argIdx))));
            }
            
          }
          return elems;
        };
        var linkStyle = {
          color: "rgb(0,0,238)",
          cursor: "pointer",
          textDecoration: "underline",
          textDecorationColor: "rgb(0,0,238)"
        };
        var rndRef = function (pRec) {
          var match = pRec.proof;
          if (match.TAG === "Hypothesis") {
            return match.label;
          }
          var label = match.label;
          var tmp = {
            borderRadius: "3px"
          };
          var tmp$1 = getFrmLabelBkgColor(label);
          if (tmp$1 !== undefined) {
            tmp.backgroundColor = tmp$1;
          }
          return React.createElement("span", {
                      style: Object.assign({}, linkStyle, tmp),
                      onClick: MM_react_common.clickHnd(undefined, undefined, undefined, undefined, (function () {
                              openFrameExplorer(label);
                            }))
                    }, label);
        };
        var expBtnBaseStyle = {
          border: "1px solid",
          color: "lightgrey",
          cursor: "pointer",
          fontFamily: "courier",
          fontSize: "10px",
          marginRight: "3px",
          padding: "1px 3px 0px 2px"
        };
        var rndExpBtn = function (state, pRecIdx) {
          var match = state.vData[pRecIdx];
          var style = match !== undefined ? expBtnBaseStyle : Object.assign({}, expBtnBaseStyle, {
                  opacity: "0"
                });
          return React.createElement("a", {
                      style: style,
                      onClick: (function (param) {
                          modifyState(function (__x) {
                                if (__x.expandedIdxs.includes(pRecIdx)) {
                                  var newrecord = Caml_obj.obj_dup(__x);
                                  newrecord.expandedIdxs = __x.expandedIdxs.filter(function (i) {
                                        return i !== pRecIdx;
                                      });
                                  return newrecord;
                                }
                                var newrecord$1 = Caml_obj.obj_dup(__x);
                                newrecord$1.expandedIdxs = __x.expandedIdxs.concat([pRecIdx]);
                                return newrecord$1;
                              });
                        })
                    }, state.expandedIdxs.includes(pRecIdx) ? "-" : "+");
        };
        var rndExprText = function (state, pRec) {
          return React.createElement(MM_cmp_pe_stmt.make, {
                      modalRef: modalRef,
                      ctx: state.frmCtx,
                      syntaxTypes: state.syntaxTypes,
                      frms: state.frms,
                      frameRestrict: preCtxData.settingsV.val.allowedFrms.inSyntax,
                      parenCnt: state.parenCnt,
                      stmt: pRec.expr,
                      symColors: state.symColors,
                      symRename: undefined,
                      editStmtsByLeftClick: preCtxData.settingsV.val.editStmtsByLeftClick,
                      openExplorer: openExplorer
                    });
        };
        var rndExprSvg = function (state, vDataRec) {
          var labelIdxs = state.showTypes ? vDataRec.hypLabels : vDataRec.eHyps.map(function (i) {
                  return vDataRec.hypLabels[i];
                });
          return React.createElement(MM_cmp_jstf_to_svg.make, {
                      hyps: state.showTypes ? vDataRec.hyps : vDataRec.eHyps.map(function (i) {
                              return vDataRec.hyps[i];
                            }),
                      hypLabels: labelIdxs.map(function (i) {
                            return String(getStepNum(state, i));
                          }),
                      asrt: vDataRec.asrt,
                      subs: vDataRec.subs,
                      frmColors: Caml_option.some(vDataRec.frmColors),
                      ctxColors1: Caml_option.some(state.symColors),
                      onLabelClick: (function (i, param) {
                          $$location.hash = "#" + proofTableId + "-" + String(labelIdxs[i]);
                        })
                    });
        };
        var rndExpr = function (state, pRec, pRecIdx) {
          var vDataRec = state.vData[pRecIdx];
          return React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", {
                                  style: {
                                    verticalAlign: "top"
                                  }
                                }, rndExpBtn(state, pRecIdx)), React.createElement("td", {
                                  style: {
                                    verticalAlign: "top"
                                  }
                                }, vDataRec !== undefined && state.expandedIdxs.includes(pRecIdx) ? rndExprSvg(state, vDataRec) : rndExprText(state, pRec)))));
        };
        var rndPagination = function (state) {
          var match = state.proofTable;
          if (match === undefined) {
            return null;
          }
          var proofTableSize = getAllProofRecordsToShow(state).length;
          if (proofTableSize < state.proofRecordsPerPage) {
            return null;
          } else {
            return React.createElement("div", {
                        style: {
                          padding: "5px"
                        }
                      }, React.createElement(PaginationCmp.make, {
                            numOfPages: Core__Math.Int.ceil(proofTableSize / state.proofRecordsPerPage),
                            pageIdx: state.pageIdx,
                            siblingCount: 1000,
                            itemsPerPage: state.proofRecordsPerPage,
                            showGoToPage: false,
                            showItemsPerPage: false,
                            onPageIdxChange: actGoToPage
                          }));
          }
        };
        var rndProof = function (state) {
          var tdStyle = {
            border: "1px solid black",
            borderCollapse: "collapse",
            padding: "5px",
            verticalAlign: "verticalAlign"
          };
          var rowStyle = ReactDOMStyle.unsafeAddProp({}, "scrollMarginTop", String(top) + "px");
          var match = state.proofTable;
          if (match !== undefined) {
            var minIdx = Math.imul(state.pageIdx, state.proofRecordsPerPage);
            var maxIdx = (minIdx + state.proofRecordsPerPage | 0) - 1 | 0;
            return React.createElement(Expln_React_Column.make, {
                        spacing: 0,
                        children: Caml_option.some(null)
                      }, state.frame.isAxiom ? React.createElement("span", {
                              style: {
                                fontWeight: "bold"
                              }
                            }, "Syntax breakdown") : React.createElement(Button, {
                              onClick: (function (param) {
                                  modifyState(toggleShowTypes);
                                }),
                              children: Caml_option.some(state.showTypes ? "Hide types" : "Show types")
                            }), React.createElement("table", {
                            id: proofTableId,
                            style: Object.assign({}, tdStyle, {
                                  tableLayout: "fixed",
                                  width: "100%"
                                })
                          }, React.createElement("thead", undefined, React.createElement("tr", undefined, React.createElement("th", {
                                        style: Object.assign({}, tdStyle, {
                                              width: stepWidth
                                            })
                                      }, "Step"), React.createElement("th", {
                                        style: Object.assign({}, tdStyle, {
                                              width: hypWidth
                                            })
                                      }, "Hyp"), React.createElement("th", {
                                        style: Object.assign({}, tdStyle, {
                                              width: refWidth
                                            })
                                      }, "Ref"), React.createElement("th", {
                                        style: tdStyle
                                      }, "Expression"))), React.createElement("tbody", undefined, getAllProofRecordsToShow(state).filter(function (param, idx) {
                                      if (minIdx <= idx) {
                                        return idx <= maxIdx;
                                      } else {
                                        return false;
                                      }
                                    }).map(function (param) {
                                    var idx = param[1];
                                    var pRec = param[0];
                                    return React.createElement("tr", {
                                                key: String(idx),
                                                id: proofTableId + "-" + String(idx),
                                                style: rowStyle
                                              }, React.createElement("td", {
                                                    className: classColStep,
                                                    style: Object.assign({}, tdStyle, {
                                                          verticalAlign: "top",
                                                          width: stepWidth
                                                        })
                                                  }, String(getStepNum(state, idx))), React.createElement("td", {
                                                    className: classColHyp,
                                                    style: Object.assign({}, tdStyle, {
                                                          verticalAlign: "top",
                                                          width: hypWidth
                                                        })
                                                  }, rndHyp(state, pRec)), React.createElement("td", {
                                                    className: classColRef,
                                                    style: Object.assign({}, tdStyle, {
                                                          verticalAlign: "top",
                                                          width: refWidth
                                                        })
                                                  }, rndRef(pRec)), React.createElement("td", {
                                                    style: tdStyle
                                                  }, rndExpr(state, pRec, idx)));
                                  }))));
          }
          if (!state.frame.isAxiom) {
            return "This assertion doesn't have a proof.";
          }
          if (state.syntaxProofTableWasRequested) {
            return "Building a syntax breakdown...";
          }
          var msg = state.syntaxProofTableError;
          if (msg !== undefined) {
            return React.createElement("pre", {
                        style: {
                          color: "red"
                        }
                      }, "Could not build a syntax breakdown: " + msg);
          } else {
            return React.createElement(Button, {
                        onClick: (function (param) {
                            actSyntaxProofTableWasRequested();
                          }),
                        children: "Show syntax breakdown"
                      });
          }
        };
        var rndFooter = function () {
          return Belt_Array.range(1, 12).map(function (i) {
                      return React.createElement("span", {
                                  key: String(i),
                                  style: {
                                    fontSize: "20px"
                                  }
                                }, Common.nbsp);
                    });
        };
        if (match$1[0]) {
          return React.createElement(Button, {
                      onClick: (function (param) {
                          actRefreshOnPreCtxDataChange();
                        }),
                      variant: "contained",
                      style: {
                        margin: "10px"
                      },
                      children: "Refresh"
                    });
        } else if (state !== undefined) {
          return React.createElement(Expln_React_Column.make, {
                      spacing: 3,
                      style: {
                        padding: "5px 10px"
                      },
                      children: Caml_option.some(null)
                    }, rndMainMenu(state), rndLabel(state), rndDescr(state), rndUsageCnt(state), rndDisj(state), rndDummyVarDisj(state), rndSummary(state), rndPagination(state), rndProof(state), rndPagination(state), rndFooter());
        } else if (loadErr !== undefined) {
          return React.createElement("pre", {
                      style: {
                        color: "red",
                        margin: "10px"
                      }
                    }, "Error: " + loadErr);
        } else if (loadPct < 1.0) {
          return "Loading the context " + Common.floatToPctStr(loadPct);
        } else {
          return "Building the proof table...";
        }
      }), propsAreSame);

exports.makeFrameProofData = makeFrameProofData;
exports.frameProofDataToEditorStateLocStor = frameProofDataToEditorStateLocStor;
exports.frameProofDataToStmtsDto = frameProofDataToStmtsDto;
exports.make = make;
/* location Not a pure module */
